import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const ASK_QUESTION = gql`
  mutation AskQuestion($input: AskQuestionInput!) {
    askQuestion(input: $input) {
      title
      description
      topics
      askedBy {
        ...identificationFields
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

// Update answer content
export const QUESTION_CONTENT_UPDATE = gql`
  mutation QuestionContentUpdate($input: QuestionContentUpdateInput!) {
    questionContentUpdate(input: $input) {
      title
      askedBy {
        ...identificationFields
      }
      isAuthorAnonymous
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

// Update by user actions (follow, pass on, comment)
export const QUESTION_ACTIONS_UPDATE = gql`
  mutation QuestionActionsUpdate($input: QuestionActionsUpdateInput!) {
    questionActionsUpdate(input: $input) {
      title
      askedBy {
        ...identificationFields
      }
      followedBy {
        ...identificationFields
      }
      passedOnBy {
        ...identificationFields
      }
      isAuthorAnonymous
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;
